import { optimizeBannerDesktopAndXlarge, optimizeBannerMobile, optimizeBannerTablet } from "@faire/retailer-visitor-shared/views/brand/BrandHeader/optimizeBannerImageUrl";
import { isManuallyCroppedImage, optimizeImageUrl } from "@faire/web--source/common/images/optimizeImages";
import { MIN_WIDTH_BREAKPOINTS } from "@faire/web--source/common/media";
// Keep in descending order for media queries
var POPULAR_DISPLAY_PIXEL_RATIOS = [
    3,
    2,
    1
];
// Keep in ascending order for media queries
var BANNER_WIDTHS = [
    MIN_WIDTH_BREAKPOINTS.TABLET - 1,
    MIN_WIDTH_BREAKPOINTS.TABLET,
    MIN_WIDTH_BREAKPOINTS.TABLET + 1,
    MIN_WIDTH_BREAKPOINTS.DESKTOP - 1,
    MIN_WIDTH_BREAKPOINTS.DESKTOP
];
export var buildBannerImageSrcSet = function(image) {
    var isSSR = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    if (isManuallyCroppedImage(image)) {
        return {
            src: optimizeImageUrl(image, isSSR, {
                height: 240
            }),
            srcset: undefined,
            sizes: undefined
        };
    }
    var desktopAndAboveSrc = optimizeBannerDesktopAndXlarge(image, isSSR);
    var tabletSrc = optimizeBannerTablet(image, isSSR);
    var mobileSrc = optimizeBannerMobile(image, isSSR, 120);
    var bannerWidthSrcMapping = BANNER_WIDTHS.map(function(width) {
        if (width >= MIN_WIDTH_BREAKPOINTS.DESKTOP) {
            return {
                width: width,
                src: desktopAndAboveSrc
            };
        }
        if (width >= MIN_WIDTH_BREAKPOINTS.TABLET) {
            return {
                width: width,
                src: tabletSrc
            };
        }
        return {
            width: width,
            src: mobileSrc
        };
    });
    var srcset = bannerWidthSrcMapping.map(function(param) {
        var width = param.width, src = param.src;
        return "".concat(src, " ").concat(width, "w");
    }).join(", ");
    var dprSizes = POPULAR_DISPLAY_PIXEL_RATIOS.map(function(dpr) {
        return "(-webkit-min-device-pixel-ratio: ".concat(dpr, ") ").concat(100 / dpr, "vw");
    }).join(", ");
    return {
        src: desktopAndAboveSrc,
        srcset: srcset,
        sizes: "".concat(dprSizes, ", 100vw")
    };
};
